export default __webpack_public_path__ + "static/media/2.bc9b4b87.svg";